import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6 col-sm-4 col-md-2" }
const _hoisted_3 = { class: "form-check" }
const _hoisted_4 = {
  class: "form-check-label",
  for: "ranked-any"
}
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = {
  class: "form-check-label",
  for: "ranked-yes"
}
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = {
  class: "form-check-label",
  for: "ranked-no"
}
const _hoisted_9 = { class: "col-6 col-sm-4 col-md-2" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = {
  class: "form-check-label",
  for: "opponent-any"
}
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = {
  class: "form-check-label",
  for: "opponent-player"
}
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = {
  class: "form-check-label",
  for: "opponent-ai"
}
const _hoisted_16 = { class: "col-12 col-sm-4 col-md-2" }
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = {
  class: "form-check-label",
  for: "states-ended"
}
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = {
  class: "form-check-label",
  for: "states-canceled"
}
const _hoisted_21 = { class: "col-12 col-md-6" }
const _hoisted_22 = { class: "input-group mb-3" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "input-group-text" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = {
  class: "form-check-label",
  for: "sort-asc"
}
const _hoisted_28 = { class: "form-check" }
const _hoisted_29 = {
  class: "form-check-label",
  for: "sort-desc"
}

import { PropType, toRefs, ref, watchEffect } from 'vue';
import SearchGamesParameters from '../../../shared/app/SearchGamesParameters.js';
import SearchPlayersParameters from '../../../shared/app/SearchPlayersParameters.js';
import { getSearchPlayers } from '../../apiClient.js';
import { BIconArrowRight, BIconX } from 'bootstrap-icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSearchGamesParameters',
  props: {
    searchGamesParameters: {
        type: Object as PropType<SearchGamesParameters>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const { searchGamesParameters } = toRefs(props);

const resetDateRange = () => {
    searchGamesParameters.value.fromEndedAt = undefined;
    searchGamesParameters.value.toEndedAt = undefined;
    searchGamesParameters.value.endedAtSort = 'desc';
};

const searchPlayersParameters = ref(new SearchPlayersParameters());

searchPlayersParameters.value.isBot = false;
searchPlayersParameters.value.isGuest = false;

watchEffect(() => {
    getSearchPlayers(searchPlayersParameters.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchGamesParameters).ranked) = $event)),
          value: undefined,
          class: "form-check-input",
          id: "ranked-any",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).ranked]
        ]),
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('any')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchGamesParameters).ranked) = $event)),
          value: true,
          class: "form-check-input",
          id: "ranked-yes",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).ranked]
        ]),
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('ranked_games')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchGamesParameters).ranked) = $event)),
          value: false,
          class: "form-check-input",
          id: "ranked-no",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).ranked]
        ]),
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('friendly_games')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchGamesParameters).opponentType) = $event)),
          value: undefined,
          class: "form-check-input",
          id: "opponent-any",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).opponentType]
        ]),
        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('any')), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchGamesParameters).opponentType) = $event)),
          value: "player",
          class: "form-check-input",
          id: "opponent-player",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).opponentType]
        ]),
        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('1v1')), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchGamesParameters).opponentType) = $event)),
          value: "ai",
          class: "form-check-input",
          id: "opponent-ai",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).opponentType]
        ]),
        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('bot_games')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchGamesParameters).states) = $event)),
          value: "ended",
          class: "form-check-input",
          id: "states-ended",
          autocomplete: "off"
        }, null, 512), [
          [_vModelCheckbox, _unref(searchGamesParameters).states]
        ]),
        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('game_state.ended')), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchGamesParameters).states) = $event)),
          value: "canceled",
          class: "form-check-input",
          id: "states-canceled",
          autocomplete: "off"
        }, null, 512), [
          [_vModelCheckbox, _unref(searchGamesParameters).states]
        ]),
        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('game_state.canceled')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("input", {
          type: "date",
          class: "form-control",
          value: _unref(searchGamesParameters).fromEndedAt?.toISOString().slice(0,10) ?? '',
          onInput: _cache[8] || (_cache[8] = ($event: any) => (_unref(searchGamesParameters).fromEndedAt = new Date(($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_23),
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_unref(BIconArrowRight))
        ]),
        _createElementVNode("input", {
          type: "date",
          class: "form-control",
          value: _unref(searchGamesParameters).toEndedAt?.toISOString().slice(0,10) ?? '',
          onInput: _cache[9] || (_cache[9] = ($event: any) => (_unref(searchGamesParameters).toEndedAt = new Date(($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_25),
        _createElementVNode("button", {
          class: "btn btn-sm btn-outline-danger",
          onClick: resetDateRange
        }, [
          _createVNode(_unref(BIconX))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchGamesParameters).endedAtSort) = $event)),
          value: "desc",
          class: "form-check-input",
          id: "sort-asc",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).endedAtSort]
        ]),
        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('sort_date.desc')), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(searchGamesParameters).endedAtSort) = $event)),
          value: "asc",
          class: "form-check-input",
          id: "sort-desc",
          autocomplete: "off"
        }, null, 512), [
          [_vModelRadio, _unref(searchGamesParameters).endedAtSort]
        ]),
        _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('sort_date.asc')), 1)
      ])
    ])
  ]))
}
}

})